import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const ACTION_MENU_LIST_ITEM_ACCORDION_CLASS_NAME =
	'ActionMenuListItemAccordion';
export const ACTION_MENU_LIST_ITEM_ACCORDION_CLASS_SLOTS: Array<
	keyof ActionMenuListItemAccordionClasses
> = ['root'] as const;

export type ActionMenuListItemAccordionClassSlot =
	(typeof ACTION_MENU_LIST_ITEM_ACCORDION_CLASS_SLOTS)[number];

export interface ActionMenuListItemAccordionClasses {
	root: string;
}

export type ActionMenuListItemAccordionClassKey =
	keyof ActionMenuListItemAccordionClasses;

export const getActionMenuListItemAccordionUtilityClass = (slot: string) =>
	generateUtilityClass(
		ACTION_MENU_LIST_ITEM_ACCORDION_CLASS_NAME,
		slot as ActionMenuListItemAccordionClassSlot,
	);

export const actionMenuListItemAccordionClasses: ActionMenuListItemAccordionClasses =
	generateUtilityClasses(ACTION_MENU_LIST_ITEM_ACCORDION_CLASS_NAME, ['root']);

export default actionMenuListItemAccordionClasses;
